module.exports = __webpack_public_path__ + "img/speaker-s2.145a3d73.jpg";